import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import { persistStore } from 'redux-persist'
import modules from "./reducers/modules";
import topics from "./reducers/topics";
import parts from "./reducers/parts";
import keyTerms from "./reducers/keyTerms";
import activities from "./reducers/activities";
import ui from "./reducers/ui";
import user from "./reducers/user";
import progress from "./reducers/progress";
import pages from "./reducers/pages";
import languages from "./reducers/languages";
import affiliate from "./reducers/affiliate";
import config from "./reducers/config";
import adobe from "./reducers/adobe";

const reducers = combineReducers({
  modules,
  topics,
  parts,
  keyTerms,
  activities,
  ui,
  user,
  progress,
  pages,
  languages,
  affiliate,
  config,
  adobe,
});

const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(thunk))
);

export const persistor = persistStore(store)

export default store;
